import Requests from "@/constants/Requests";
import Vue from "vue";

export const DlGroupService = {
  getMetaInfo: async function() {
    return Vue.prototype.$http.get(Requests.info.meta);
  },
  getInfoPage: async function(language) {
    // const params = new URLSearchParams();
    // params.append("set_request_language", language);
    // const response = await ApiService.get("/info/page?" + params.toString());
    return null; //response.data;
  }
};
